import keyMirror from '../assets/libs/keyMirror';

export default keyMirror({
    'text': null,
    'modify_msg': null,
    'tip': null,
    'image': null,
    'file': null,
    'video': null,
    'audio': null,
    'mix': null,
    'call_audio': null,
    'call_video': null,
    'standard_evaluate_card1': null,
    'standard_evaluate_card2': null,
    'card': null,
    'minicard': null,
    'universal_card1': null,
    'universal_card2': null,
    'universal_card3': null,
    'universal_card4': null,
    'universal_card5': null,
    'private_card_ganji': null,
    'default_contactinfo_card': null,
    'provide_contactinfo_card': null
});
